// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zXFc","col":"styles_col__1vlAy"};